import {BaseSearchableService} from "./Core/BaseSearchableService";
import {BaseService} from './Core/BaseService';
import {store} from "../Redux/store";

class SpeciesListService extends BaseSearchableService {
    get Url() { return super.Url + "/speciesLists"; }
    get ModelName() { return "Species List"; }
    get PrimaryKeyProperty() { return "speciesListId"; }
    get Request() {
        const organizationId = store.getState().contextState?.organizationId;

        return {
            ...super.Request,
            organizationId,
        };
    }

    GetSpeciesLists(stateId = null, excluded = []) {
        return this.SendRequest(BaseService.GET, {...this.Request, stateId, excluded, limit:null});
    }

    GetSpeciesList(speciesListId) {
        return this.SendRequest(BaseSearchableService.GET, speciesListId);
    }

    GetSpeciesListByContextNodeId(contextNodeId) {
        return this.SendRequest(BaseSearchableService.GET, contextNodeId, null, '/forContextNodeId');
    }

    UpdateSpeciesList(speciesList) {
        this.FlushCache();

        return this.SendRequest(BaseSearchableService.PUT, speciesList);
    }

    CreateSpeciesList(speciesList) {
        this.FlushCache();

        return this.SendRequest(BaseSearchableService.POST, speciesList);
    }

    DeleteSpeciesList(speciesListId) {
        this.FlushCache();

        return this.SendRequest(BaseSearchableService.DELETE, speciesListId);
    }

    Search(name = null, speciesListTypes = null) {
        return this.SendRequest(BaseSearchableService.GET, { name, speciesListTypes, ...this.Request});
    }
}

export const service = new SpeciesListService();

